import { deriveLogicalProjectKey } from "./logicalProject";
import type { Project } from "./types";

type GroupMember = Pick<Project, "environmentId" | "id" | "cwd" | "name" | "repositoryIdentity">;

/**
 * Every checkout belonging to a group, in the order the store reports them.
 *
 * This is what makes the settings page a GROUP page rather than a per-checkout
 * one: a laptop clone, a desktop clone and a sprite's checkout of the same repo
 * are one project with several members, and the page shows all of them.
 */
export function resolveProjectGroupMembers<T extends GroupMember>(
  groupKey: string,
  projects: readonly T[],
): readonly T[] {
  return projects.filter((project) => deriveLogicalProjectKey(project) === groupKey);
}
